var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0788376 4.63718C1.27682 2.00654 3.92359 0.176025 7.00002 0.176025C10.0765 0.176025 12.7232 2.00654 13.9212 4.63718C14.0262 4.86765 14.0262 5.13237 13.9212 5.36283C12.7232 7.99348 10.0765 9.82399 7.00002 9.82399C3.92359 9.82399 1.27682 7.99348 0.0788376 5.36283C-0.0261164 5.13237 -0.0261165 4.86765 0.0788376 4.63718ZM12.4411 4.56883C11.3146 2.65237 9.27182 1.46247 6.99998 1.46247C4.72814 1.46247 2.68534 2.65237 1.55881 4.56883C1.40228 4.83512 1.40228 5.16499 1.55881 5.43128C2.68534 7.34774 4.72814 8.53764 6.99998 8.53764C9.27182 8.53764 11.3146 7.34774 12.4411 5.43128C12.5977 5.16499 12.5977 4.83512 12.4411 4.56883ZM6.99992 3.39201C7.88754 3.39201 8.60792 4.11239 8.60792 5C8.60792 5.88762 7.88754 6.608 6.99992 6.608C6.11231 6.608 5.39193 5.88762 5.39193 5C5.39193 4.11239 6.11231 3.39201 6.99992 3.39201ZM4.10555 5.00008C4.10555 3.40495 5.40481 2.10569 6.99994 2.10569C8.59507 2.10569 9.89432 3.40495 9.89432 5.00008C9.89432 6.59521 8.59507 7.89447 6.99994 7.89447C5.40481 7.89447 4.10555 6.59521 4.10555 5.00008Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowContent);
export default __webpack_public_path__ + "static/media/ShowContent.da32e15daaa41d1ea90ee72725acceae.svg";
export { ForwardRef as ReactComponent };